export const HOME_TABS_SLOTS = [1, 6, 9];
